import React from 'react'
import ReactStars from '../../../reviews/react-stars'
import { AddReviewRequest } from '../../../../types/lobbies/requests/post-add-a-review-request'

type Props = {
  ratingValues: AddReviewRequest
  handleRatingChange: (newValue: number) => void
}
export default function RatingStarArea({
  ratingValues,
  handleRatingChange,
}: Props) {
  const starStyle = {
    count: 5,
    half: false,
    value: ratingValues.rating,
    size: 28,
    color1: '#575F67',
    color2: '#FF9900',

    onChange: handleRatingChange,
  }

  return (
    <div className={'shrink-0'}>
      <ReactStars {...starStyle}></ReactStars>
    </div>
  )
}
